import {
	BooleanInput,
	Create,
	SelectInput,
	SimpleForm,
	TextInput,
	useRedirect,
	Toolbar,
	SaveButton,
	Button,
} from 'react-admin';
import { useCallback } from 'react';
import { Stack } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const CancelButton = () => {
	const redirect = useRedirect();
	const handleCancel = useCallback(() => redirect('list', 'monitoring-statements'), [redirect]);

	return (
		<Button
			label="Abbrechen"
			startIcon={<ArrowBackIcon />}
			onClick={handleCancel}
			color="secondary"
			variant="text"
		/>
	);
};

const CustomToolbar = () => (
	<Toolbar>
		<Stack direction="row" spacing={2}>
			<SaveButton />
			<CancelButton />
		</Stack>
	</Toolbar>
);

export const MonitoringCreate = () => (
	<Create redirect="list">
		<SimpleForm
			toolbar={<CustomToolbar />}
			defaultValues={{
					status: true,
					priority: 0,
					executionTime: '12',
					threshold: '>1'
			}}
		>
			<TextInput source="description" fullWidth />
			<SelectInput
				source="database"
				choices={[
					{ id: 'SSIS', name: 'SSIS' },
					{ id: 'PROSOOM', name: 'Prosoom Live' },
					{ id: 'ANALYTICS', name: 'Analytics' },
					{ id: 'CLICKHOUSE', name: 'ClickHouse' },
				]}
			/>
			<TextInput source="statement" multiline fullWidth />
			<TextInput source="messageStatement" multiline fullWidth />
			<TextInput
				source="threshold"
				helperText={
					'Das Statement wird erst ausgeführt, wenn die Bedingung nicht erfüllt ist.'
				}/>
			<TextInput
				source="executionTime"
				helperText={
				'Zu welcher Uhrzeit soll geprüft werden?'
			}/>
			<SelectInput
				source="priority"
				choices={[
					{ id: '1', name: 'info' },
					{ id: '2', name: 'debug' },
					{ id: '3', name: 'warning' },
					{ id: '4', name: 'fatal error' },
				]}
				helperText={
					'welche Art Monitoring ist das?'
				}
			/>
			<BooleanInput source="status" />
		</SimpleForm>
	</Create>
);